<script setup lang="ts">
import LineDrawing from "@/components/LineDrawing.vue";
import FrameIconStatement from "@/components/frames/FrameIconStatement.vue";
import LineCheckpoint from "@/components/LineCheckpoint.vue";

import SectionContactWithRows from "@/components/sections/SectionContactWithRows.vue";

useSeoMeta({
  title: 'Contact Altracare | Request a Hygiene Assessment',
  description: 'Book a complimentary site assessment, request product quotes or schedule training with Altracare’s Zanzibar team supporting your hygiene compliance goals.',
  ogTitle: 'Contact Altracare | Request a Hygiene Assessment',
  ogDescription: 'Book a complimentary site assessment, request product quotes or schedule training with Altracare’s Zanzibar team supporting your hygiene compliance goals.',
  ogType: 'website',
  twitterCard: 'summary_large_image'
})
const { scrollToId } = useScrollTo()

const { hero } = useHero()

onMounted(() => {
  hero({
      media: {
        type: 'image',
        transition: {
          mode: 'out-in'
        },
        media: {
          src: '/images/food-header.jpg',
          alt: '',
        },
      },
      content: {
        model: "page",
        content: {
          hairline: 'Contact Us',
          title: 'Let’s Raise Hygiene Standards Together',
          description: 'We don’t just supply hygiene products — we provide complete support through our 360° Service model. Get in touch today to request your free assessment and discover how Altracare can help you achieve spotless results, confident teams, and assured compliance.',
          line: true,
          lineColor: 'var(--c-cyan)',
        }
      },
      overlays: {
        transition: {
          mode: 'out-in'
        },
        overlays: [{
          type: 'gradient',
          options: {
            direction: 'to bottom',
            colors: ['rgba(0, 24, 158, 0.2)', 'rgba(0, 30, 190, 0.2)'],
          },
        }]
      },
      shapes: {
        transition: {
          mode: 'out-in'
        },
        shapes: []
      },
      divider: {
        transition: {
          mode: 'out-in'
        },
        divider: {
          shape: 0,
          styles: {

          },
          options: {

          },
        }
      }
    })
})

const isMounted = useMounted()
const framer = ref(null)
const { width: framerWidth, height: framerHeight } = useElementSize(framer)
const checkpoints = ref<Checkpoint[]>([
  {
    id: "contact",
    angle: 45,
    gradient: {
      from: "#e2e8f0",
      to: "#e2e8f0"
    }
  },
  {
    id: "checkmap",
    angle: 82,
    gradient: {
      from: "#e2e8f0",
      to: "#e2e8f0"
    }
  }
])
</script>

<template>
  <Section class="page page-contact-us gpt-3 gpb-6">

    <Framer ref="framer" class="frame-primary">
      <div class="sec-background-lines ">
        <LineDrawing v-if="isMounted" :checkpoints="checkpoints" :width="framerWidth" :height="framerHeight" />
      </div>



      <Section class="sec-primary-content relative z-1">




        <FrameIconStatement v-if="false" class="row-title gmb-1">
          <template #icon>
            <LineCheckpoint id="intro" />
          </template>

          <template #statement>
            <ATitle class="ds:mw-80" hairline="Get in touch with us" primary="Contact us for a free assessment" />

            <AContent class="ds:mw-80">
              <p>We’re thrilled that you’re considering reaching out to us. At iSolvents, we take pride in offering a
                full range of innovative solutions tailored to your specific needs. Get in touch today to request your
                free, comprehensive assessment.</p>
            </AContent>
          </template>
        </FrameIconStatement>

        <SectionContactWithRows id="contactus" statement-description="" />


      </Section>

    </Framer>

  </Section>
</template>

<style lang="scss" scoped>
.sec-map {


  :deep(.mapboxgl-canvas) {
    mix-blend-mode: color-burn;
  }

  :deep(.sec-icon) {}
}
</style>
